import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { whatsappUrl } from '../content/siteContent';

const { FiNavigation, FiArrowUpRight, FiRadio } = FiIcons;

const bonaoMapUrl = 'https://media-manager-c.questera.ai/greta-media/786069decac80ebfda9758781ecad48f576fd486e338363dff55357567d6916b51c713fb933d539c7b707900e265a4cf/images/aW1hZ2UvcG5n/192bea45b15f8033bc204244ab9b2a6d.png';

function Coverage() {
  return (
    <section className="coverage section" id="cobertura">
      <div className="container coverage__grid">
        <motion.div
          className="coverage__content"
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <span className="eyebrow">
            <SafeIcon icon={FiRadio} /> Cobertura local
          </span>
          <h2>Estamos cerca <em>de ti.</em></h2>
          <p>Operamos principalmente en Bonao y zonas habilitadas de Monseñor Nouel.</p>
          <div className="coverage__status">
            <SafeIcon icon={FiNavigation} />
            <span>
              <strong>Nuestra cobertura continúa creciendo.</strong>
              Consulta tu sector antes de pedir.
            </span>
          </div>
          <a
            className="button button--large"
            href={whatsappUrl('Hola, quiero consultar si tienen cobertura en mi ubicación.')}
            target="_blank"
            rel="noreferrer"
          >
            Consultar mi ubicación <SafeIcon icon={FiArrowUpRight} />
          </a>
        </motion.div>

        <motion.div
          className="coverage-map"
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          aria-label="Mapa de cobertura de Muchacho E’ Mandao en Bonao"
        >
          <img
            src={bonaoMapUrl}
            alt="Mapa de Bonao con la zona principal de cobertura señalada"
            loading="lazy"
            style={{
              position: 'absolute',
              inset: '0',
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              objectPosition: 'center',
              padding: '18px',
              filter: 'drop-shadow(0 0 22px rgba(8, 242, 12, 0.2))'
            }}
          />
        </motion.div>
      </div>
    </section>
  );
}

export default Coverage;